<div class="contains">
    <div class="section-22">
        <div class="d-flex justify-content-center align-items-center w-100 h-100 ">
            <div class="card card-1 box-shadow">
                <div class="card-head d-flex justify-content-center align-items-center   mt-3">
                 <div class="row" ><div class="col-12 d-flex justify-content-center align-items-center"> <p class="log1"> CFSS </p> </div>
                    <div class="col-12  "> <p class="log2">Community First Service and Support</p>
                    <div class="col-12">    <h3 class="card-title head1 d-flex justify-content-center align-items-center  mt-2">
                        Login </h3></div>
                    </div>
                </div>
    
            
              
            </div>
            <div class="card-body card-2 text-center" style="margin-top: -12%;">
                <form [formGroup]="LoginForm">
                    <div class="form-group my-group" style="margin-bottom: 5px">
                        <input class="login-input w-100" type="text"   [(ngModel)]="SaveAuthRequest.userName" autocomplete="off" formControlName="Email"
                        placeholder="UserName/Email/Phone"  title="UserName"
                           name="Email">
                    </div>
                    <div *ngIf="LoginForm.controls.Email.errors && submitted ">
                        <div style="color:red;text-align: left;" *ngIf="LoginForm.controls.Email.errors.required">User
                            Required</div>
                    </div>
                    <br>
                    <div class="form-group my-group" style="margin-bottom: 4px">
                        <input class="login-input w-100" autocomplete="false" [type]="Password" [(ngModel)]="SaveAuthRequest.password"
                        placeholder="Password" title="Password"
                            formControlName="WebPassword"  name="WebPassword">
                            <i class="bi bi-eye-fill"    *ngIf="show_pass" (click)="showPass()" ></i>
                            <i class="bi bi-eye-slash-fill" *ngIf="!show_pass" (click)="showPass()" ></i>
                    </div>
                    <div *ngIf="LoginForm.controls.WebPassword.errors && submitted">
                        <div style="color:red;text-align: left;" *ngIf="LoginForm.controls.WebPassword.errors.required">
                            Required</div>
                    </div>
                    <br>
                    <div class="form-group my-group" style="margin-bottom: 4px">
                        <input class="login-input w-100" autocomplete="false" type="text" [(ngModel)]="SaveAuthRequest.agencyCode"
                        placeholder="AgencyCode" title="AgencyCode"
                            formControlName="agencycode"  name="agencycode">
                    </div>
                    <div *ngIf="LoginForm.controls.agencycode.errors && submitted">
                        <div style="color:red;text-align: left;" *ngIf="LoginForm.controls.agencycode.errors.required">
                            Required</div>
                    </div>
                    <br>
                    <button type="submit" class="btn "
                        style="color: #fff;height: 40px;width:250px;background-color: #198578;font-size:1.4rem !important;padding: 0 !important;border-radius:2.5rem;"
                        [disabled]="!LoginForm.valid" 
                        (click)="LoginDataFunction()">Login</button>
                </form>

                <div class="mt-4">
                    <p   style="background: white;color:#198578;border:0px;font-size:16px; cursor: pointer;" (click)="forgotpassword()" > Forgot Password?</p>
                </div>
                <div>
                    <p>Version :{{versioncontrolnumber}}</p>
                </div>
                <div class="text-center border border-white bg-transparent">
                </div>
            </div>
        </div>
    </div>
    </div>
</div>



<!--  Multiple roles  login  --> 
<span id="openmultilogin" data-bs-target="#multilogin" data-bs-toggle="modal"></span>
<div class="modal fade" id="multilogin" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog create-update-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Role Login</h5>
            </div>
            <div class="modal-body">
                <div class="d-inline-flex col-lg-12">
                    <label class="w-50">Select Role</label>
                    <select  [(ngModel)]="SaveAuthRequest.roleId" class="form-control w-50">
                        <option *ngFor=" let val of RoleList" [value]="val.Key">{{val.Value}}</option>
                    </select>
                </div>
            </div>
            <div class="modal-footer">

                <button class="btn blue-btn btn-sm butstyle "  
                [disabled]="SaveAuthRequest.roleId==null || SaveAuthRequest.roleId==undefined || SaveAuthRequest.roleId==''"
                data-bs-dismiss="modal"   (click)="LoginDataFunction()">Login
                </button>
                <button class="btn blue-btn btn-sm butstyle " data-bs-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>

 
   
